// extracted by mini-css-extract-plugin
export var base = "InputTextareaField-module--base--d120f";
export var caution = "InputTextareaField-module--caution--b9732";
export var container = "InputTextareaField-module--container--ab125";
export var counter = "InputTextareaField-module--counter--56153";
export var message = "InputTextareaField-module--message--02352";
export var textarea = "InputTextareaField-module--textarea--6fee9";